export default __webpack_public_path__ + "static/media/comedora.f64ffa99.png";